<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-analysis/modelList' }"
              >模型管理</el-breadcrumb-item
            >
            <el-breadcrumb-item
              ><a @click.prevent="goBack">新建模型</a></el-breadcrumb-item
            >
            <el-breadcrumb-item>{{
              isEdit ? "编辑风险模块" : "新建风险模块"
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-form
          ref="myForm"
          :model="formData"
          :rules="formRules"
          :label-width="formLabelWidth"
        >
          <el-form-item label="风险模块名称:" prop="pattern_item_name">
            <el-input
              class="el-input-width-1205"
              v-model="formData.pattern_item_name"
            ></el-input>
          </el-form-item>
          <el-form-item label="风险类型:" prop="pattern_item_risk_id">
            <el-select
              class="el-selet-width-800"
              placeholder="请选择"
              v-model="formData.pattern_item_risk_id"
              filterable
              @change="getRiskFieldArr"
            >
              <el-option
                v-for="item in riskTypeData"
                :key="item.id"
                :label="item.full_risk_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">风险分值项(B):</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <zv-table :table="table1" ref="dataTable1"> </zv-table>
            </div>
          </div>
          <el-form-item
            label="基础分值计算公式:"
            class="paddint-t-20"
            prop="base_score_formula"
          >
            <el-input
              class="el-input-width-1205"
              v-model="formData.base_score_formula"
              readonly
            ></el-input>
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">加权项(W):</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <zv-table :table="table2" ref="dataTable2"> </zv-table>
            </div>
          </div>
          <el-form-item
            label="加权值计算公式:"
            class="paddint-t-20"
            prop="weight_score_formula"
          >
            <el-input
              class="el-input-width-1205"
              v-model="formData.weight_score_formula"
              readonly
            ></el-input>
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">特殊加权项(S):</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <zv-table :table="table3" ref="dataTable3"> </zv-table>
            </div>
          </div>
          <el-form-item
            class="form-item-label-lh-auto paddint-t-20"
            prop="special_weight_score_formula"
            label="特殊加权值计算公式:"
          >
            <el-input
              class="el-input-width-1205"
              v-model="formData.special_weight_score_formula"
              :value="formData.special_weight_score_formula"
              readonly
            ></el-input>
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">减分项(R):</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <zv-table :table="table4" ref="dataTable4"> </zv-table>
            </div>
          </div>
          <el-form-item
            label="减分项计算公式:"
            class="paddint-t-20"
            prop="minus_score_formula"
          >
            <el-input
              class="el-input-width-1205"
              v-model="formData.minus_score_formula"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="total_score_formula"
            label="当前模块总计算公式:"
            class="form-item-label-lh-auto"
          >
            <el-input
              class="el-input-width-1205"
              v-model="formData.total_score_formula"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="auto" class="fi-flex-center paddint-t-30">
            <el-button @click="doCancel">取消</el-button>
            <el-button type="primary" @click="doSubmit"
              >保存，返回模型页</el-button
            >
            <el-button type="primary" @click="doSubmit"
              >保存，继续新增模块</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
import EventBus from "@/utils/services/event_service";
export default {
  name: "CreateModelItem",
  mixins: [formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      id: "", // 事件编辑时id
      targetType: "", // 模型类型，华人或通用
      isEdit: false, // 是否为编辑
      formData: {
        pattern_item_name: "", // 模块名字
        pattern_item_risk_id: "", // 模块项目风险分类ID
        base_risk_field_id: "", // 开通的基础评分项目参考因素ID 多个项目用,隔开
        base_score_formula: "" // 基础评分公式 B
      },
      formRules: {
        pattern_item_name: {
          required: true,
          message: "风险模块名称不能为空",
          trigger: "blur"
        },
        pattern_item_risk_id: {
          required: true,
          message: "风险类型不能为空",
          trigger: "change"
        }
        // base_score_formula: {
        //   required: true,
        //   message: "基础评分公式不能为空",
        //   trigger: "blur"
        // },
        // weight_score_formula: {
        //   required: true,
        //   message: "加权值计算公式不能为空",
        //   trigger: "blur"
        // },
        // special_weight_score_formula: {
        //   required: true,
        //   message: "特殊加权值计算公式不能为空",
        //   trigger: "blur"
        // },
        // minus_score_formula: {
        //   required: true,
        //   message: "减分项计算公式不能为空",
        //   trigger: "blur"
        // },
        // total_score_formula: {
        //   required: true,
        //   message: "当前模块总计算公式不能为空",
        //   trigger: "blur"
        // }
      },
      riskTypeData: [], // 风险类型
      table1: {
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        data: [],
        columns: [
          {
            title: "参考因素名称",
            key: "field_name",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "参考因素得分编号",
            key: "first_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "参考因素权重编号",
            key: "second_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "生效状态",
            key: "status",
            minWidth: "150",
            align: "center",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status
                },
                on: {
                  change(status) {
                    vm.doChangeRFStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          }
        ]
      },
      table2: {
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        data: [],
        columns: [
          {
            title: "加权项类型",
            key: "text",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "加权项编号",
            key: "first_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "加权项配置值编号",
            key: "second_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "生效状态",
            key: "status",
            minWidth: "150",
            align: "center",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status
                },
                on: {
                  change(status) {
                    vm.doChangeWeightStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          }
        ]
      },
      table3: {
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        data: [],
        columns: [
          {
            title: "特殊加权项类型",
            key: "text",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "特殊加权项编号",
            key: "first_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "特殊加权项配置值编号",
            key: "second_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "生效状态",
            key: "status",
            minWidth: "150",
            align: "center",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status
                },
                on: {
                  change(status) {
                    vm.doChangeSpecialWeightStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          }
        ]
      },
      table4: {
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        data: [],
        columns: [
          {
            title: "减分项类型",
            key: "text",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "减分项项编号",
            key: "first_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "减分配置值编号",
            key: "second_no",
            minWidth: "150",
            align: "center"
          },
          {
            title: "生效状态",
            key: "status",
            minWidth: "150",
            align: "center",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status
                },
                on: {
                  change(status) {
                    vm.doChangeMinusStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          }
        ]
      }
    };
  },
  computed: {},

  methods: {
    initCommonData() {
      this.$commFunc.getRiskTypeList().then(resData => {
        this.riskTypeData = resData;
      });
    },

    initAddData() {
      this.getWeightFieldArr();
      this.getSpecialWeightFieldArr();
      this.getMinusFieldArr();
    },

    async initEditData() {
      let resData = await api.modelItemDetail({
        id: this.id
      });
      console.log(resData);
      this.processEditData(resData.info);
      this.getWeightFieldArr(true);
      this.getSpecialWeightFieldArr(true);
      this.getMinusFieldArr(true);
    },

    processEditData(resData) {
      let processObj = Object.assign({}, this.formData, resData);
      let filterRiskArr = processObj.base_field_list.filter(
        item => item.target_type == this.targetType
      );
      filterRiskArr.forEach(item => {
        let tempArr = processObj.base_risk_field_id.split(",");
        let findIndex = tempArr.findIndex(subItem => subItem == item.id);
        item.status = findIndex > -1 ? true : false;
      });
      this.setRiskFieldArr(filterRiskArr, true);

      this.formData = processObj;
    },

    // 获取风险类型详情
    async getRiskFieldArr(riskId) {
      let resData = await api.riskTypeInfo({
        id: riskId
      });
      let filterArr = resData.info.risk_field.filter(
        item => item.target_type == this.targetType
      );
      this.setRiskFieldArr(filterArr);
    },

    setRiskFieldArr(dataArr, isInit) {
      dataArr.forEach(item => {
        item.first_no = `B${item.id}`;
        item.second_no = `Pb${item.id}`;
        item.status = isInit ? item.status : true;
      });

      console.log(dataArr);

      this.setTable1Data(dataArr);
    },

    doChangeRFStatus(status, id) {
      this.table1.data.forEach(item => {
        if (item.id == id) {
          item.status = status;
        }
      });
      this.setTable1Data(this.table1.data);
    },

    setScoreFormula() {
      let retStr = "";
      let retArr = [];
      if (this.table1 && this.table1.data && this.table1.data.length) {
        this.table1.data.forEach(item => {
          if (item.status) {
            retArr.push(item.first_no + "*" + item.second_no);
          }
        });
      }
      if (retArr.length) {
        retStr = "基础分值B=" + retArr.join("+");
      }
      this.$set(this.formData, "base_score_formula", retStr);
    },

    setTable1Data(tableData) {
      this.$set(this.table1, "data", tableData);
      this.setScoreFormula();
    },

    getWeightFieldArr(isInit) {
      let resData = [
        {
          id: 1,
          text: "关联性",
          formKey: "weight_is_related_on"
        },
        {
          id: 2,
          text: "触发重大时间节点",
          formKey: "weight_is_festival_on"
        },
        {
          id: 3,
          text: "影响性",
          formKey: "weight_is_effect_area_on"
        },
        {
          id: 4,
          text: "是否流血事件",
          formKey: "weight_is_effect_bleeding_on"
        }
      ];

      resData.forEach(item => {
        let status = true;
        if (isInit == true) {
          if (this.formData[item.formKey] == 0) {
            status = false;
          }
        }
        item.first_no = `W${item.id}`;
        item.second_no = `Pw${item.id}`;
        item.status = status;
      });

      this.setTable2Data(resData);
    },

    doChangeWeightStatus(status, id) {
      this.table2.data.forEach(item => {
        if (item.id == id) {
          item.status = status;
        }
      });
      this.setTable2Data(this.table2.data);
    },

    setWeightFormula() {
      let retStr = "";
      let retArr = [];
      if (this.table2 && this.table2.data && this.table2.data.length) {
        this.table2.data.forEach(item => {
          if (item.status) {
            retArr.push(item.first_no);
          }
        });
      }
      if (retArr.length) {
        retStr = "加权值W=" + retArr.join("+");
      }
      this.$set(this.formData, "weight_score_formula", retStr);
    },

    setTable2Data(tableData) {
      this.$set(this.table2, "data", tableData);
      this.setWeightFormula();
    },

    getSpecialWeightFieldArr(isInit) {
      let resData = [
        {
          id: 1,
          text: "特殊加权项",
          formKey: "special_weight_is_on"
        }
      ];

      resData.forEach(item => {
        let status = true;
        if (isInit == true) {
          if (this.formData[item.formKey] == 0) {
            status = false;
          }
        }
        item.first_no = `S${item.id}`;
        item.second_no = `Ps${item.id}`;
        item.status = status;
      });

      this.setTable3Data(resData);
    },

    doChangeSpecialWeightStatus(status, id) {
      this.table3.data.forEach(item => {
        if (item.id == id) {
          item.status = status;
        }
      });
      this.setTable3Data(this.table3.data);
    },

    setSpecialWeightFormula() {
      let retStr = "";
      let retArr = [];
      if (this.table3 && this.table3.data && this.table3.data.length) {
        this.table3.data.forEach(item => {
          if (item.status) {
            retArr.push(item.first_no);
          }
        });
      }
      if (retArr.length) {
        retStr = "特殊加权值S=" + retArr.join("+");
      }
      this.$set(this.formData, "special_weight_score_formula", retStr);
    },

    setTable3Data(tableData) {
      this.$set(this.table3, "data", tableData);
      this.setSpecialWeightFormula();
    },

    getMinusFieldArr(isInit) {
      let resData = [
        {
          id: 1,
          text: "减分项",
          formKey: "minus_is_on"
        }
      ];

      resData.forEach(item => {
        let status = true;
        if (isInit == true) {
          if (this.formData[item.formKey] == 0) {
            status = false;
          }
        }
        item.first_no = `R${item.id}`;
        item.second_no = `Pr${item.id}`;
        item.status = status;
      });

      this.setTable4Data(resData);
    },

    doChangeMinusStatus(status, id) {
      this.table4.data.forEach(item => {
        if (item.id == id) {
          item.status = status;
        }
      });
      this.setTable4Data(this.table4.data);
    },

    setMinusFormula() {
      let retStr = "";
      let retArr = [];
      if (this.table4 && this.table4.data && this.table4.data.length) {
        this.table4.data.forEach(item => {
          if (item.status) {
            retArr.push(item.first_no);
          }
        });
      }
      if (retArr.length) {
        retStr = "减分值R=" + retArr.join("+");
      }
      this.$set(this.formData, "minus_score_formula", retStr);
    },

    setTable4Data(tableData) {
      this.$set(this.table4, "data", tableData);
      this.setMinusFormula();
    },

    doCancel() {
      this.$router.back();
    },

    doSubmit() {
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message("请检查表单!", "warning");
          return;
        }
        let apiFunc = this.isEdit ? api.editModelItem : api.addModelItem;
        let processObj = this.processSubmitData();
        console.log(processObj);
        let res = await apiFunc(processObj);
        console.log(res);
        let msg = this.isEdit ? "修改模型成功" : "新增模型成功";
        TipUtil.message(msg, "success");
        // 新建模块回填模块id
        if (!this.isEdit) {
          processObj.id = res.pattern_item_id;
        }
        EventBus.$emit(
          "updateModelItemData",
          this.$_.pick(processObj, ["id", "pattern_item_name", "risk_name"])
        );
        this.goBack();
      });
    },

    processSubmitData() {
      let processObj = this.$_.cloneDeep(this.formData);

      // 获取开通的基础评分项目参考因素ID 多个项目用,隔开
      let scoreFieldArr = [];
      this.table1.data.forEach(item => {
        if (item.status) {
          scoreFieldArr.push(item.id);
        }
      });

      processObj.base_risk_field_id = scoreFieldArr.join(",");
      let tableDatas = [this.table2.data, this.table3.data, this.table4.data];
      tableDatas.forEach(dataItem => {
        dataItem.forEach(subItem => {
          processObj[subItem.formKey] = subItem.status ? 1 : 0;
        });
      });
      let riskFilterArr = this.riskTypeData.filter(
        item => item.id == processObj.pattern_item_risk_id
      );
      processObj.risk_name = riskFilterArr.length
        ? riskFilterArr[0].full_risk_name
        : "";
      delete processObj.patter_reduce_arr;
      delete processObj.pattern_item;

      let checkEmptyArr = [
        "base_score_formula",
        "weight_score_formula",
        "special_weight_score_formula",
        "minus_score_formula",
        "total_score_formula"
      ];
      checkEmptyArr.forEach(item => {
        if (!processObj[item]) {
          delete processObj[item];
        }
      });

      return processObj;
    }
  },
  created() {
    let id = this.$route.query.id;
    if (id) {
      this.id = id;
      this.isEdit = true;
    }
    this.targetType = this.$route.query.targetType;
  },
  mounted() {
    this.initCommonData();
    if (this.isEdit) {
      this.initEditData();
    } else {
      this.initAddData();
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped></style>
